import { toast } from '../components/notifications';
import { apiService } from './api';
import { haptic } from '../utils/haptics';

/**
 * Gemeinsamer Session-Beitritt fuer alle Klick-Wege (SessionCard, SessionsPage,
 * MainScreen, App-Handler). Vorher gab es vier eigene Implementierungen - jeder
 * Join-Fix musste mehrfach gemacht werden (z.B. das justJoined-Overlay).
 *
 * Ein Request: POST /sessions/:id/join validiert einen mitgegebenen Code direkt
 * (initialStatus VALIDATED) und behandelt auch den Rejoin nach LEFT korrekt.
 * QR-Scan/Code-Seite laufen weiterhin ueber SessionJoinManager (verify-code,
 * dort ist die Session-ID unbekannt).
 *
 * @param {string} sessionId - Session-ID
 * @param {function} navigate - react-router navigate
 * @param {object} [options]
 * @param {string} [options.code] - Session-Code (optional; ohne Code: PENDING/RESERVED)
 * @param {string} [options.joinContext] - Forschung: Provenienz ('OPEN_LIST' | 'QR' | 'CODE')
 * @returns {Promise<object>} Backend-Response
 * @throws bei Fehler (nach toast.error) - Caller koennen Inline-Fehler anzeigen,
 *         duerfen aber KEINEN eigenen Toast mehr zeigen (sonst doppelt)
 *
 * Erfolg zeigt bewusst KEINEN Toast: Der User landet sofort auf der Session-Seite,
 * sieht dort das Otter-Overlay und seinen Status-Badge ("Reserviert"/"Dabei").
 * Ein Toast obendrauf war doppeltes Feedback (Sep 2026, Toast-Noise-Regel).
 */
export async function joinSessionAndNavigate(sessionId, navigate, { code, joinContext } = {}) {
  try {
    const response = await apiService.joinSession(sessionId, code, joinContext);

    if (!response?.success) {
      throw new Error(response?.error || 'Fehler beim Beitreten der Session');
    }

    haptic.success();

    // justJoined: SessionDetailPage zeigt das Erfolgs-Overlay (Otter-Animation)
    navigate(`/session/${sessionId}`, { state: { justJoined: true } });

    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message || 'Fehler beim Beitreten der Session';
    toast.error(errorMessage, { position: 'top-center', autoClose: 4000 });
    throw error;
  }
}
